import React from 'react'
import load from '../../../assets/unnamed.gif'
// import load from '../../../assets/loading (2).svg'
const Loader = () => {
    return (
        <div className="w-full h-screen flex items-center justify-center bg-white">
            <div className="min-w-full h-screen flex justify-center items-center ">
        < img src = { load } alt = "" className = "w-[400px] " />
            </div >
        </div >
    )
}

export default Loader